import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  defaultSetAddress,
  deleteMemberAddress,
  fetchListMemberAddress,
} from "../../../api/memberAddress";
import { failAlert, successAlert } from "../../../common/alert";
import * as Addr from "./MyAddress-styles";
import NewMyAddress from "./new/MyAddress-new";
import { isLoaded } from "../../../redux/action/loading";

const pageHeaderStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "12px",
  marginBottom: "22px",
};

const titleStyle = {
  margin: 0,
  fontSize: "22px",
  fontWeight: 800,
  color: "#222",
};

const subTextStyle = {
  margin: "6px 0 0",
  fontSize: "14px",
  color: "#777",
};

const addButtonStyle = {
  height: "42px",
  padding: "0 18px",
  border: "1px solid #3BB77E",
  borderRadius: "8px",
  background: "#3BB77E",
  color: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

const listWrapperStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gap: "16px",
};

const cardStyle = (isBasic) => ({
  position: "relative",
  border: isBasic ? "1px solid #3BB77E" : "1px solid #e5e7eb",
  borderRadius: "14px",
  background: "#fff",
  padding: "22px",
  boxShadow: isBasic
    ? "0 4px 14px rgba(59,183,126,0.12)"
    : "0 2px 10px rgba(0,0,0,0.035)",
});

const badgeStyle = {
  display: "inline-flex",
  alignItems: "center",
  height: "26px",
  padding: "0 10px",
  borderRadius: "13px",
  background: "#e9f7f0",
  color: "#3BB77E",
  fontSize: "12px",
  fontWeight: 800,
  marginBottom: "12px",
};

const addressNameStyle = {
  margin: 0,
  fontSize: "18px",
  fontWeight: 800,
  color: "#222",
};

const infoListStyle = {
  listStyle: "none",
  padding: 0,
  margin: "18px 0 0",
};

const infoItemStyle = {
  display: "grid",
  gridTemplateColumns: "86px 1fr",
  gap: "10px",
  fontSize: "14px",
  lineHeight: 1.6,
  marginBottom: "8px",
};

const labelStyle = {
  color: "#777",
  fontWeight: 700,
};

const valueStyle = {
  color: "#333",
  wordBreak: "keep-all",
};

const buttonAreaStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "8px",
  marginTop: "22px",
  paddingTop: "16px",
  borderTop: "1px solid #f1f1f1",
};

const outlineButtonStyle = {
  height: "36px",
  padding: "0 13px",
  border: "1px solid #ddd",
  borderRadius: "7px",
  background: "#fff",
  color: "#333",
  fontSize: "13px",
  fontWeight: 700,
  cursor: "pointer",
};

const greenOutlineButtonStyle = {
  ...outlineButtonStyle,
  border: "1px solid #3BB77E",
  color: "#3BB77E",
};

const applyButtonStyle = {
  height: "36px",
  padding: "0 15px",
  border: "1px solid #3BB77E",
  borderRadius: "7px",
  background: "#3BB77E",
  color: "#fff",
  fontSize: "13px",
  fontWeight: 700,
  cursor: "pointer",
};

const emptyBoxStyle = {
  minHeight: "260px",
  border: "1px dashed #cfd8dc",
  borderRadius: "14px",
  background: "#fafafa",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  padding: "50px 20px",
  textAlign: "center",
};

const MyAddress = ({ isLoaded, loading, ownProps }) => {
  const [myAddress, setMyAddress] = useState();
  const [myAddressCount, setMyAddressCount] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editAddress, setEditAddress] = useState();

  const fetchAddressList = async () => {
    const res = await fetchListMemberAddress();
    setMyAddressCount(res.Data?.Count || 0);
    setMyAddress(res.Data?.Rows || []);
    isLoaded();
  };

  const deleteAddress = async (acode) => {
    const body = {
      modes: "DeleteSet",
      acode,
    };

    const res = await deleteMemberAddress(body);

    if (res?.code === "0000") {
      successAlert("삭제 되었습니다.");
      fetchAddressList();
    } else {
      failAlert(res?.data?.Msg);
    }
  };

  const selectDefault = async (acode) => {
    const body = {
      modes: "DefaultSet",
      acode,
    };

    const res = await defaultSetAddress(body);

    if (res.code === "0000") {
      successAlert("설정되었습니다.");
      fetchAddressList();
    } else {
      failAlert(res.data.Msg);
    }
  };

  const handleIsEdit = (el) => {
    setIsEdit(true);
    setIsOpen(true);
    setEditAddress(el);
  };

  const openCreateAddress = () => {
    setIsEdit(false);
    setEditAddress(undefined);
    setIsOpen(true);
  };

  const applyCheckoutAddress = (el) => {
    ownProps.setMemberAddress(el);
    ownProps.setUserInputs({
      ...ownProps.userInputs,
      acode: el.acode,
      base_addr: el.base_addr,
      detail_addr: el.detail_addr,
      doro_addr: el.doro_addr,
      addressGps: { mapx: el.mapx, mapy: el.mapy },
      addr_name: el.name,
      zipcode: el.zipcode,
    });
    ownProps.setOpenAddressModal(false);
  };

  useEffect(() => {
    fetchAddressList();
  }, []);

  return (
    <>
      {loading === false &&
        (!isOpen ? (
          <Addr.Container>


            <div
              style={{
                marginBottom: "16px",
                fontSize: "14px",
                fontWeight: 700,
                color: "#3BB77E",
              }}
            >
              총 {myAddressCount}개
            </div>

            {myAddress?.length > 0 ? (
              <div style={listWrapperStyle}>
                {myAddress.map((el, i) => {
                  const isBasic = el.basic === "Y";

                  return (
                    <div key={el.acode || i} style={cardStyle(isBasic)}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "10px",
                        }}
                      >
                        <div>
                          <h4 style={addressNameStyle}>
                            {el.name || "배송지"}
                          </h4>
                          <p
                            style={{
                              margin: "6px 0 0",
                              fontSize: "13px",
                              color: "#999",
                            }}
                          >
                            {el.zipcode ? `우편번호 ${el.zipcode}` : ""}
                          </p>
                        </div>

                        <div
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            background: isBasic ? "#e9f7f0" : "#f5f5f5",
                            color: isBasic ? "#3BB77E" : "#999",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flex: "0 0 40px",
                          }}
                        >
                          <i className="fi-rs-marker" />
                        </div>
                      </div>

                      <ul style={infoListStyle}>
                        <li style={infoItemStyle}>
                          <strong style={labelStyle}>도로명</strong>
                          <span style={valueStyle}>
                            {el.doro_addr || "-"}
                          </span>
                        </li>

                        <li style={infoItemStyle}>
                          <strong style={labelStyle}>지번</strong>
                          <span style={valueStyle}>
                            {el.base_addr || "-"}
                          </span>
                        </li>

                        <li style={infoItemStyle}>
                          <strong style={labelStyle}>상세주소</strong>
                          <span style={valueStyle}>
                            {el.detail_addr || "-"}
                          </span>
                        </li>
                      </ul>

                      <div style={buttonAreaStyle}>
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          {ownProps.isCheckout && (
                            <button
                              type="button"
                              style={applyButtonStyle}
                              onClick={() => applyCheckoutAddress(el)}
                            >
                              적용
                            </button>
                          )}
                          <button
                            type="button"
                            disabled={isBasic}
                            onClick={() => !isBasic && selectDefault(el.acode)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "6px",
                              height: "36px",
                              minWidth: "145px",
                              padding: "0 14px",
                              borderRadius: "18px",
                              border: "1px solid #3BB77E",
                              background: isBasic ? "#3BB77E" : "#fff",
                              color: isBasic ? "#fff" : "#3BB77E",
                              fontSize: "13px",
                              fontWeight: 700,
                              cursor: isBasic ? "default" : "pointer",
                              transition: "all .2s",
                            }}
                          >
                            <i className={isBasic ? "fi-rs-check" : "fi-rs-home"} />
                            {isBasic ? "기본 배송지" : "기본 배송지로 등록"}
                          </button>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                          }}
                        >
                          <button
                            type="button"
                            style={outlineButtonStyle}
                            onClick={() => handleIsEdit(el)}
                          >
                            수정
                          </button>

                          <button
                            type="button"
                            style={outlineButtonStyle}
                            onClick={() => deleteAddress(el.acode)}
                          >
                            삭제
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={{ marginTop: "24px" }}>
                <div onClick={openCreateAddress} style={emptyBoxStyle}>
                  <div
                    style={{
                      width: "58px",
                      height: "58px",
                      borderRadius: "50%",
                      background: "#e9f7f0",
                      color: "#3BB77E",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: "26px",
                      marginBottom: "16px",
                    }}
                  >
                    <i className="fi-rs-plus" />
                  </div>

                  <h5
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: 800,
                      color: "#333",
                    }}
                  >
                    등록된 배송지가 없습니다
                  </h5>

                  <p
                    style={{
                      margin: "8px 0 0",
                      fontSize: "14px",
                      color: "#777",
                    }}
                  >
                    클릭하면 새 배송지를 등록할 수 있습니다.
                  </p>
                </div>
              </div>
            )}
          </Addr.Container>
        ) : (
          <NewMyAddress
            isCheckout={ownProps.isCheckout}
            setIsOpen={setIsOpen}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            isOpen={isOpen}
            editAddress={editAddress}
            fetchAddressList={fetchAddressList}
            deleteAddress={deleteAddress}
          />
        ))}
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  loading: state.loading.loading,
  ownProps,
});

const mapDispatchToProps = {
  isLoaded,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyAddress);